//React
import { faTrash } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import axios from "axios"
import React from "react"
import { Link, useNavigate } from "react-router-dom"
import { useAuthContext } from "../../../Hooks/useAuthContext"

export default function InteractionsList({ interactions, setContact }) {
  const { user, dispatch } = useAuthContext()
  const navigate = useNavigate()
  

  const handleDeleteInteraction = async (id) => {
    try {
      const res = await axios.delete(
        `https://${process.env.REACT_APP_IP}/api/interaction/${id}`,
        {
          headers: { Authorization: `bearer ${user.token}` },
        }
      )
      console.log(res.data)
      setContact((prev) => {
        return {
          ...prev,
          interactions: prev.interactions.filter(
            (interaction) => interaction.id !== id
          ),
        }
      })
    } catch (error) {
      if (error.response.status === 401) {
        dispatch({ type: "LOGOUT" })
        navigate("../../expired")
      } else {
        // setError(error.response.status)
      }
    }
  }
  return (
    <div className="mb-3">
      <h3 className=" mb-3">Interactions</h3>
      <hr />
      <div>
        {interactions && interactions.length > 0 ? (
          interactions.map((interaction) => (
              <div className="row ps-2 mb-2 innerCon  p-2" key={interaction.id}>
                <div className="col-11">

                      {/* Interaction With / Type */}
                      <p className="text-decoration-underline">
                          {new Date(interaction.dateAndTime).toLocaleDateString()}&nbsp;-&nbsp;
                          <Link to={`/users/view_user/${interaction.handledById}`}>{`${interaction.handledBy}`}</Link>{" - "}
                          {`${interaction.type}`}
                      </p>

                  {/* Enqiry Link */}
                  <Link to={`/enquiries/view_enquiry/${interaction.enquiryId}`}>
                      {interaction.title
                          ? interaction.title
                          : "Un-Named Enquiry"}
                  </Link>


                    
                  
               
              
                    <div className={`d-flex flex-column flex-md-row `}>
                        <p>{interaction.description}</p>
                    </div>
                </div>
              
             
                <div className="col-1">
                    <button
                      className="btn btn-danger"
                      onClick={() => handleDeleteInteraction(interaction.id)}
                    >
                        <FontAwesomeIcon icon={faTrash} />
                    </button>
                </div>
            </div>
          ))
        ) : (
          <div className=" text-center">No interactions found.</div>
        )}
      </div>
    </div>
  )
}
